import axios from "../../config/axiosConfig";
import { GET_PRODUCTION_PURCHASE_TRANSACTIONS, PRODUCTION_PURCHASE_TRANSACTION_REQUEST, PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE, GET_PRODUCTION_PURCHASE_TRANSACTIONS_TAKA_NO,
  GET_PRODUCTION_PURCHASE_TRANSACTIONS_BY_BEAM
 } from "../types";

export const getProductionPurchaseTransaction = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production-purchase-transaction/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_PURCHASE_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getProductionPurchaseTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production-purchase-transaction/getAll", { params }).then((response) => {
        const takaNos = response.data.map((data) => ({
          Taka_No: data.Taka_No,
          Book_Id: data?.Production?.Book_Id,
          Account_Id: data?.Production?.Account_Id,
          Type: data?.Production_Type,
          Voucher_No: data?.Production?.Vch_No,
        }));
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_PURCHASE_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getProductionPurchaseTransactionsByBeam = (beamId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/production-purchase-transaction/getTakaByBeam/${beamId}`, { params }).then((response) => {
        console.log('<<Beam-Taka--', response);
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_PURCHASE_TRANSACTIONS_BY_BEAM, payload: response.data });
        }
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
}

